import clsx from 'clsx'
import React from 'react'

import { VimeoPlayer } from '@Components/CMS/Video/VimeoPlayer'
import { ImageV3 } from '@Components/Image'
import { ReferenceContentFragment } from '@Generated/graphql'

import styles from './styles.module.scss'

export const Background = ({
  asset,
  className,
  priority,
  sizes,
  ...props
}: React.ComponentProps<'div'> & {
  asset?: ReferenceContentFragment
  priority?: boolean
  sizes?: string
}) => {
  if (!asset || !asset.__typename) {
    return null
  }

  if (asset.__typename === 'Image' && asset.url) {
    return (
      <div className={clsx(styles.background, className)} {...props}>
        <ImageV3
          alt=""
          className={styles.image}
          draggable={false}
          fill
          priority={priority}
          sizes={sizes || '100vw'}
          src={asset.url}
        />
      </div>
    )
  }

  if ((asset.__typename === 'ImageAsset' || asset.__typename === 'ImageResource' || asset.__typename === 'Link') && asset.image?.url) {
    return (
      <div className={clsx(styles.background, className)} {...props}>
        <ImageV3
          alt=""
          className={styles.image}
          draggable={false}
          fill
          priority={priority}
          sizes={sizes || '100vw'}
          src={asset.image.url}
        />
      </div>
    )
  }

  if (asset.__typename === 'VideoResource' && asset.asset?.type === 'vimeo' && asset.asset?.key) {
    return (
      <div className={clsx(styles.background, className)} {...props}>
        <VimeoPlayer
          className={clsx(styles.video, 'vimeoVideo')}
          enableControls={false}
          options={{
            autoplay: true,
            muted: true,
            loop: true,
          }}
          videoID={asset.asset.key}
        />
      </div>
    )
  }

  return null
}
